import { Navigate } from 'react-router-dom';
import { ReactSession } from '../utils/ReactSession.jsx';
import {AES, enc} from "crypto-js";
import { useParams } from "react-router";
import Areas from "./Areas.jsx";
import Residents from "./Residents.jsx";
import Devices from "./Devices.jsx";
import AreaGroups from "./AreaGroups.jsx";
import SystemDevices from "./SystemDevices.jsx";
import ServerDevices from "./ServerDevices.jsx";
import {iAmHigherAuthority} from "../libs.jsx";
import ResidentGroups from "./ResidentGroups.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import WanderDevices from "./WanderDevices.jsx";

const Community = (props) => {
    let pageContent, dData, paramVars, bData;
    paramVars = useParams();

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }
    if (paramVars.dType === "areas"){
        if (paramVars?.eType === "groups"){
            pageContent = <AreaGroups />;
        }else{
            pageContent = <Areas />;
        }
    }else if (paramVars.dType === "residents"){
        if (paramVars?.eType === "groups"){
            pageContent = <ResidentGroups />;
        }else{
            pageContent = <Residents />;
        }
    }else if (paramVars.dType === "devices"){
        pageContent = <Devices />;
    }else if (paramVars.dType === "system_devices" && iAmHigherAuthority(99, dData?.role_weight)) {
        pageContent = <SystemDevices />;
    }else if (paramVars.dType === "server_devices" && iAmHigherAuthority(99, dData?.role_weight)) {
        pageContent = <ServerDevices />;
    }else if (paramVars.dType === "wander_devices") {
        pageContent = <WanderDevices />;
    }else{
        pageContent = (
            <div>
                404 Page not found
            </div>
        );
    }

    return (iAmHigherAuthority(10, dData?.role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {pageContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Community;